import { SchedulingPage } from "./scheduling-page"

export default function Home() {
  return <SchedulingPage />
}
